export enum DimensionUnitEnum {
    CM = 'CM',
    IN = 'IN'
}
